module.exports = __webpack_public_path__ + "img/icon_soccer_redCard.5d9baa31.svg";